import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/qr/index';
import QRScan from './QRScan';

const ms2p = (state) => {
    return {
        ...state.qr_users,
        me: state.login.me,
    }
};


const md2p = { ...actions };

export default connect(ms2p, md2p)(QRScan);